import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { api } from './api';
import { useAuth } from './auth-context';

interface BillingStatus {
  status: string;
  trialEndsAt: string | null;
  daysRemaining: number | null;
  isDemo: boolean;
  isActive: boolean;
  isBlocked: boolean;
}

interface BillingContextType {
  billing: BillingStatus | null;
  loading: boolean;
}

const BillingContext = createContext<BillingContextType>({ billing: null, loading: true });

export function BillingProvider({ children }: { children: ReactNode }) {
  const { isLoggedIn } = useAuth();
  const [billing, setBilling] = useState<BillingStatus | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setBilling(null);
      return;
    }
    setLoading(true);
    api.getBillingStatus().then(r => {
      if (r.success && r.data) setBilling(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [isLoggedIn]);

  return (
    <BillingContext.Provider value={{ billing, loading }}>
      {children}
    </BillingContext.Provider>
  );
}

export function useBilling() {
  return useContext(BillingContext);
}
